function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
export {
  combineURLs as default
};
//# sourceMappingURL=axios31.js.map
